/*=============================================== CardPage ===============================================*/

import { Card, Image, Flexbox, Text, Button } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { borderObject, radiusObject, paddingObject } from "data"

const CardPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Card
                    flexDirection="column"
                    alignItems="stretch"
                    padding={0}
                    border={{
                        color: "gray-200",
                    }}
                    maxWidth={400}
                >
                    <Image
                        src="https://images.unsplash.com/photo-1644722126641-d01298483d5a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHx0b3BpYy1mZWVkfDd8Ym84alFLVGFFMFl8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=60"
                        alt="Img"
                        height={150}
                        fit="cover"
                    />

                    <Flexbox
                        flexDirection="column"
                        alignItems="stretch"
                        padding="xs"
                    >
                        <Text tag="h4">Title</Text>
                        <Text>Hello</Text>
                        <Flexbox justifyContent="flex-end">
                            <Button>Button</Button>
                        </Flexbox>
                    </Flexbox>
                </Card>
            ),
            code: '<Card\n    flexDirection="column"\n    alignItems="stretch"\n    padding={0}\n    border={{\n        color: "gray-200",\n    }}\n    maxWidth={400}\n>\n    \n</Card>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "width",
            type: "string or number",
        },
        {
            subtitle: "height",
            type: "string or number",
        },
        {
            subtitle: "maxWidth",
            type: "string or number",
        },
        {
            subtitle: "backgroundImg",
            type: "string",
        },
        ...borderObject(),
        ...radiusObject(),
        ...paddingObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default CardPage
